var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactsDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "g818",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.234,
    height: 52.233,
    viewBox: "0 0 52.234 52.233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M45.705,0H14.364A6.537,6.537,0,0,0,7.835,6.529v6.529H1.306a1.306,1.306,0,1,0,0,2.612H7.835v5.223H1.306a1.306,1.306,0,1,0,0,2.612H7.835v5.223H1.306a1.306,1.306,0,1,0,0,2.612H7.835v5.223H1.306a1.306,1.306,0,1,0,0,2.612H7.835V45.7a6.537,6.537,0,0,0,6.529,6.529H45.705A6.537,6.537,0,0,0,52.234,45.7V6.529A6.537,6.537,0,0,0,45.705,0Zm3.918,45.705a3.922,3.922,0,0,1-3.918,3.918H14.364a3.922,3.922,0,0,1-3.918-3.918V6.529a3.922,3.922,0,0,1,3.918-3.918H45.705a3.922,3.922,0,0,1,3.918,3.918Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M34.438,24.378a6.529,6.529,0,1,0-8.807,0,11.757,11.757,0,0,0-7.349,10.88,1.306,1.306,0,0,0,2.612,0,9.141,9.141,0,1,1,18.282,0,1.306,1.306,0,0,0,2.612,0,11.757,11.757,0,0,0-7.35-10.88Zm-8.321-4.79a3.918,3.918,0,1,1,3.918,3.918,3.918,3.918,0,0,1-3.918-3.918Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsDark);
export default __webpack_public_path__ + "static/media/contacts_dark.8db69f4378557341ecf56d1a28dd837a.svg";
export { ForwardRef as ReactComponent };